import Icon from '@material-ui/icons/Flag';
export default Icon;